import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GalleryService } from '../../providers/gallery.service';
import { LoggerService } from '../../providers/logger.service';

@Component({
  selector: 'app-redirect-googledrive',
  templateUrl: './redirect-googledrive.component.html',
  styleUrls: ['./redirect-googledrive.component.css']
})
export class RedirectGoogledriveComponent implements OnInit {

  constructor(private logger: LoggerService,
    private route: ActivatedRoute,
    private router: Router,
    private gallery: GalleryService) { }

  ngOnInit(): void {
    this.activate();
  }

  activate() {
    try {
      var code = this.route.snapshot.params['code'];
      var state = this.route.snapshot.params['state'];

      this.gallery.doGoogleDriveLoginAction('login',
        'code=' + encodeURIComponent(code) +
        '&state=' + encodeURIComponent(state)
      ).then(
        (data) => {
          try {
            if (data['url']) {
              this.router.navigate([data['url']], {});
            } else {
              console.log('GDRIVE: Got invalid response.', data);
              this.logger.write2log('redirect-googledrive-dologin.2', 'Got invalid response.', 'E');
              this.router.navigate(["/gallery/"], {});
            }
          } catch (e) {
            this.logger.write2log('redirect-googledrive-dologin.3', e.message, 'E');
            this.router.navigate(["/gallery/"], {});
          }
        });

    } catch (e) {
      this.logger.write2log('redirect-googledrive-dologin', e.message, 'E');
    }
  }

}
